import AsyncAlpine from 'async-alpine';
import Alpine from "alpinejs";
import intersect from '@alpinejs/intersect';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import persist from '@alpinejs/persist';

/* 1st party */
import { app } from "./app.js";
import assetLoaded from "./assetLoaded.js";
import html5Video from './html5Video/index.js';
import { moodboard } from './moodboard.js';
import popup from './popup';
import slideshow from './slideshow';

/* plugins */
Alpine.plugin(AsyncAlpine);
Alpine.plugin(intersect);
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(persist);

/* data components */
Alpine.data("app", app);
Alpine.data("assetLoaded", assetLoaded);
Alpine.data("html5Video", html5Video);
Alpine.data("moodboard", moodboard);
Alpine.data("popup", popup);
Alpine.data("slideshow", slideshow);

/* stores */
Alpine.store('prefersReducedMotion', window.matchMedia('(prefers-reduced-motion: reduce)').matches);

Alpine.asyncData('mapbox', () => import('./mapbox.js'));

/* start your engines */
window.Alpine = Alpine;
Alpine.start();
